import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dash-mileage-modal',
  templateUrl: './dash-mileage-modal.component.html',
  styleUrls: ['./dash-mileage-modal.component.scss']
})
export class DashMileageModalComponent {

  @Input() vrm: string;
  @Input() quoteStateId: number;

  constructor(private modalService: NgbModal) { }

  dismissModal() {
    this.modalService.dismissAll();
  }
}
